import React, { memo, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useLiveStreamAppContext } from "../ContextStore/Store";
import { appInsightTrack } from "../utils/AppInsights";
import { useState } from "react";
import { Link } from "react-router-dom";
import ProgressBarDrive from "../Components/ProgressBarDrive";
import axios from "axios";

const formatFileSize = (sizeInKB) => {
  if (sizeInKB >= 1024 * 1024) {
    // If the size is large enough, convert to GB
    return (sizeInKB / (1024 * 1024)).toFixed(2) + " GB";
  } else if (sizeInKB >= 1024) {
    // If it's larger than 1MB but less than 1GB, convert to MB
    return (sizeInKB / 1024).toFixed(2) + " MB";
  } else {
    return sizeInKB.toFixed(2) + " Kb";
  }
};

function DrivePlanPopupModal(props) {
  const defaultPlanStorage = props.vagarodriveplanlist.find(
    (plan) => plan.isSelected
  );
  const driveSizeCalculate = props.drivesizecalculate;

  const {
    __merchantId,
    __userId,
    setInformationContent,
    setShowInformationStrip,
    apiUrlPost,
  } = useLiveStreamAppContext();
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [newPlan, setNewPlan] = useState(null);
  const [adminSelectionPlan, setAdminSelectionPlan] = useState(null);

  //useEffect for Disabling Default Plan Storage buttons
  useEffect(() => {
    if (defaultPlanStorage) {
      setSelectedPlan(defaultPlanStorage);
      setNewPlan(defaultPlanStorage);
    }
  }, [defaultPlanStorage]);

  if (!props.drivesizecalculate) return;

  // Calculate the total file usage (in MB or GB depending on your needs)
  const totalUsage =
    driveSizeCalculate.appointmentFileUsage +
    driveSizeCalculate.businessFileUsage +
    driveSizeCalculate.classFileUsage +
    driveSizeCalculate.customerFileUsage +
    driveSizeCalculate.formsFileUsage;

  //Function to Select New Plan from Vagaro Drive Popup
  const handlePlanSelect = (plan) => {
    setAdminSelectionPlan(plan.planName);
    setNewPlan(plan);
    props.setstoragedigit(plan.usageLimit);
  };

  //Function for Api Call for Upgrading Vagaro Drive Plan
  const handleVagaroDriveUpgrade = async () => {
    if (adminSelectionPlan === null) {
      setShowInformationStrip(true);
      setInformationContent({
        type: "alert",
        message: "Please select a plan to upgrade.",
      });
      return;
    }
    const payload = {
      vagaroDrivePlanName: adminSelectionPlan,
      isVagaroDriveEnable: true,
      isVagaroDriveGetStarted: true,
      isCreateNewPath: true,
      driveContainerName: props.uploaddrivecontainername,
    };

    const headers = {
      "Content-Type": "application/json",
      userId: __userId,
      merchantId: __merchantId,
    };

    try {
      const response = await axios.post(
        `${apiUrlPost}upgradevagarodriveplan`,
        payload,
        { headers }
      );
      if (response) {
        props.onHide(false);
      }

      // Dispose or reset sensitive data after use
      payload.vagaroDrivePlanName = null;
      payload.isVagaroDriveEnable = null;
      payload.isVagaroDriveGetStarted = null;
      payload.isCreateNewPath = null;
      payload.containerId = null;

      if (response.data) {
        props.setdriveplanmodalshow(false);
      }
    } catch (error) {
      setShowInformationStrip(true);
      setInformationContent({
        type: "alert",
        message: error.message,
      });
      appInsightTrack(
        __merchantId,
        __userId,
        "API Error upgrading Vagaro Drive",
        "",
        error
      );
      console.error("Error upgrading Vagaro Drive:", error);
    }
  };

  return (
    <>
      <Modal
        className="livestreamPopup storage-popup"
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            <h4 className="modal-title">Your Vagaro Drive Has Low Storage</h4>

            <i
              className="font-awesome-light-pro live-popup-close"
              style={{ cursor: "pointer" }}
              onClick={() => {
                props.setdriveplanmodalshow(false);
              }}
            >
              &#xf00d;
            </i>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="clearfix default-scrollbar">
          <label className="lable-storage">
            Your Vagaro Drive no longer has enough storage to save this video
            recording. Upgrade your plan for more storage to save this video
            file.
          </label>
          <div className="queue-size-grp" id="divProgressbar">
            <label>Current Plan</label>
            <div className="queue-size" id="DivUsedDataInfo">
              {formatFileSize(totalUsage)} of {defaultPlanStorage.usageLimit} GB
              Used
            </div>
            <ProgressBarDrive
              driveSizeCalculateData={driveSizeCalculate}
              defaultPlanStorage={defaultPlanStorage}
            />
          </div>

          {driveSizeCalculate && (
            <div id="divProgressbarInfo">
              <div className="storage-plan-screen">
                <div className="st-data-up">
                  <div className="planCategory">
                    <div className="st-data-symbol-Form"></div>
                    <div className="st-data-detail">
                      <div className="filename">Forms File</div>
                      <div className="datause">
                        <span id="spnFormsFileUsage">
                          {formatFileSize(driveSizeCalculate.formsFileUsage)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="planCategory">
                    <div className="st-data-symbol-CustAppo"></div>
                    <div className="st-data-detail">
                      <div className="filename">Customer Appt. File</div>
                      <div className="datause">
                        <span id="spnCustomerApptFileUsage">
                          {formatFileSize(
                            driveSizeCalculate.appointmentFileUsage
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="planCategory">
                    <div className="st-data-symbol-CustFile"></div>
                    <div className="st-data-detail">
                      <div className="filename">Customer File</div>
                      <div className="datause">
                        <span id="CustomerFileUsage">
                          {formatFileSize(driveSizeCalculate.customerFileUsage)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="planCategory">
                    <div className="st-data-symbol-BusinessFile"></div>
                    <div className="st-data-detail">
                      <div className="filename">Business File</div>
                      <div className="datause">
                        <span id="BusinessFileUsage">
                          {formatFileSize(driveSizeCalculate.businessFileUsage)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="planCategory">
                    <div className="st-data-symbol-DemandVideo"></div>
                    <div className="st-data-detail">
                      <div className="filename">Class File</div>
                      <div className="datause">
                        <span id="spnClassFileUsage">
                          {formatFileSize(driveSizeCalculate.classFileUsage)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="st-plan-list">
            {props.vagarodriveplanlist &&
            props.vagarodriveplanlist.length > 0 ? (
              props.vagarodriveplanlist.map((item) => {
                // Disable all plans with usageLimit <= selectedPlan.usageLimit
                const isDisabled =
                  selectedPlan && item.usageLimit <= selectedPlan.usageLimit;
                // Only plans with higher usageLimit than the selected plan should be active
                const isActive = item.usageLimit > selectedPlan?.usageLimit;
                return (
                  <div
                    key={item.vagaroDriveId}
                    className={`list-box ${
                      isDisabled ? "disabledStorage" : ""
                    }`}
                    data-planname={item.planName}
                  >
                    <Link
                      className={`
                            ${
                              selectedPlan &&
                              item?.vagaroDriveId === newPlan?.vagaroDriveId
                                ? "active"
                                : item?.vagaroDriveId ===
                                  selectedPlan?.vagaroDriveId
                                ? "active"
                                : ""
                            }
                          `}
                      data-planname={item.planName}
                      data-usagelimit={item.usageLimit}
                      onClick={(e) => isActive && handlePlanSelect(item)}
                    >
                      <strong>{item.planName}</strong>
                      <span>
                        {item.currencySymbol} {item.price}/mo
                      </span>
                    </Link>
                  </div>
                );
              })
            ) : (
              <p>No plans available.</p>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="cbtn brd-btn margin-right16"
            onClick={() => {
              props.setdriveplanmodalshow(false);
            }}
          >
            No Thanks
          </button>
          <button
            className="cbtn thm-btn"
            onClick={() => handleVagaroDriveUpgrade()}
          >
            Upgrade
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default memo(DrivePlanPopupModal);
